import { jsx } from "react/jsx-runtime";
function SearchFormGrid({ children, gridClassName, ariaLabel, onSubmit }) {
    return /*#__PURE__*/ jsx("div", {
        className: "w-auto",
        children: /*#__PURE__*/ jsx("form", {
            className: "w-auto",
            "aria-label": ariaLabel,
            onSubmit: onSubmit,
            children: /*#__PURE__*/ jsx("div", {
                className: "mx-auto w-auto",
                children: /*#__PURE__*/ jsx("div", {
                    className: gridClassName,
                    children: children
                })
            })
        })
    });
}
export { SearchFormGrid };
